// extracted by mini-css-extract-plugin
export default {"container":"link-button_container__1Kzbm","buttonInner":"link-button_buttonInner__2lVwP","empty":"link-button_empty__1yDie"};